import { render } from "./giftshowDetail.vue?vue&type=template&id=0c9c9194&scoped=true"
import script from "./giftshowDetail.vue?vue&type=script&lang=js"
export * from "./giftshowDetail.vue?vue&type=script&lang=js"

import "./giftshowDetail.vue?vue&type=style&index=0&id=0c9c9194&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c9c9194"]])

export default __exports__